"use strict";
'use es6';
/* ABC order please */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE = exports.REQUEST_CHANGES = exports.REORDER = exports.REFRESH = exports.FETCH = exports.DELETE = exports.CREATE = exports.APPROVE = void 0;
var APPROVE = 'APPROVE';
exports.APPROVE = APPROVE;
var CREATE = 'CREATE';
exports.CREATE = CREATE;
var DELETE = 'DELETE';
exports.DELETE = DELETE;
var FETCH = 'FETCH';
exports.FETCH = FETCH;
var REFRESH = 'REFRESH';
exports.REFRESH = REFRESH;
var REORDER = 'REORDER';
exports.REORDER = REORDER;
var REQUEST_CHANGES = 'REQUEST_CHANGES';
exports.REQUEST_CHANGES = REQUEST_CHANGES;
var UPDATE = 'UPDATE';
exports.UPDATE = UPDATE;